var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'toaster tw-fixed tw-toast tw-z-toast',
    _vm.toasterPosition,
    (_vm.isStatic ? 'toaster-static' : 'toaster-root'),
  ]},[_c('div',{staticClass:"toaster-slot tw-w-[21.5rem]"},[(!!_vm.isStatic)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }